import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { getWorkerQualifications } from "@src/utils/agent";
import { useMemo } from "react";

/**
 * @deprecated Use the `useWorkerQualifications` hook from the `@src/appV2/Worker/useWorkerQualifications` file instead.
 */
export function useWorkerQualificationsDeprecated() {
  const worker = useDefinedWorker();

  const workerQualifications = useMemo((): string[] => {
    return getWorkerQualifications(worker);
  }, [worker]);

  return workerQualifications;
}
